import {config} from '../config';

export default {
    getIsPauseModeEnabled: (deviceType) => config.data.pauseModeGuide.pauseModeGuideEnabled.includes(deviceType),
    getIsClosePauseModePopup: () => config.data.pauseModeGuide.isClosePauseModePopup,
    getIsAutoSlideEnabled: () => config.data.pauseModeGuide.isAutoSlideEnabled,
};
